import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Print from '../views/Print.vue'
import Error404 from '../views/Error404.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Certificados, Hospital Dois Pinheiros',
    component: Home
  },
  {
    path: '/imprimir',
    name: 'Imprimir Certificado, Hospital Dois Pinheiros',
    component: Print
  },
  {
    path: '*',
    name: 'Error404',
    component: Error404
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach(to => {
  document.title = to.name
  window.scrollTo(0, 0)
})

export default router
